import api from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../Booker.Web/node_modules/css-loader/dist/cjs.js!../../../Booker.Web/node_modules/resolve-url-loader/index.js!../../../Booker.Web/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-3.use[3]!./views.login.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};